<!--<ng-container *ngIf="HasRequiredPermissions">-->




    <div class="">

        <!-- Informations du rôle -->
        <div class="mt-4">
          <h3 class="{{Skin.formSectionSmallTitle}}">
            <i class="fa-solid fa-user"></i> {{'components.validationCode.email-phone' | translate}}
          </h3>
            <div class="space-y-2">
                <div>
                    <!--<label class="{{Skin.upperCaseSmallLabel}}">{{ 'entities.validationCode.propreties.identificationData' | translate }}</label>-->

                    <input type="text" autocomplete="off"
                           id="emailOrPhoneInput"
                           onReady (autoBind)="bindingHandler($event, 'identificationData')"
                           (change)="onFieldChange()"
                           placeholder="{{ 'components.validationCode.email-phone-invite' | translate }}"
                           class="{{Skin.formInputMediumSize}} bg-gray-200 placeholder:text-gray-400 text-center py-1 border-1 border-gray-400 focus:bg-white focus:border-green-500 focus:shadow-lg"
                           [class.border-red-500]="hasValidationErrors('identificationData')">
                    @if (hasValidationErrors('identificationData')) {
                    <div class="text-red-600 text-xs mt-1">
                        @for (error of getValidationErrors('identificationData'); track error) {
                        <div>{{ error | translate }}</div>
                        }
                    </div>
                    }
                </div>

            </div>
            <div class="mt-1">

                <div>
                  <button [disabled]="$safeNavigationMigration(editingEntity()?.validationCode)"
                          type="button" (click)="generateVerificationCode()"
                          class="relative {{Skin.btnPrimary}} uppercase py-2 px-2 w-[100%] justify-center ml-auto mr-auto
                           disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ">
                    &nbsp;&nbsp;
                    {{ 'buttons.generate-verification-code' | translate }} &nbsp;&nbsp; <i class="fas fa-qrcode text-3xl absolute right-[22%] max-[700px]:right-[50px]"></i> &nbsp;&nbsp;
                  </button>
                </div>
            </div>
        </div>

        <div class="mt-4">
          <h3 class="{{Skin.formSectionSmallTitle}}">
            <i class="fa-solid fa-qrcode"></i> {{'components.validationCode.code' | translate}}
          </h3>
            <div class="space-y-2">
                <div>
                    <input id="verificationCode" type="text" autocomplete="off"
                           onReady (autoBind)="bindingHandler($event, 'validationCode')"
                           (change)="onFieldChange()"
                           placeholder="{{ 'components.validationCode.code-invite' | translate }}"
                           class="{{Skin.formInputMediumSize}} bg-gray-200 placeholder:text-gray-400 text-center py-1 border-3 border-1 border-gray-400 focus:bg-white focus:border-green-500 focus:shadow-lg"
                           [class.border-red-500]="hasValidationErrors('validationCode')">
                </div>
            </div>
        </div>
        <div class="mt-1">
            <div class="space-y-2">
                <div>
                  <button type="button" (click)="validateCode()"
                          class="relative {{Skin.btnPrimary}} text-x uppercase py-2 px-2 w-[100%] justify-center ml-auto mr-auto
                           disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                          [disabled]="!editingEntity()?.validationCode">
                    &nbsp;&nbsp;
                    {{ 'buttons.trucker-checkout-validate' | translate }}  &nbsp;&nbsp;
                    <i class="fa-regular fa-circle-check text-3xl ml-2 absolute right-[22%] max-[700px]:right-[50px] "></i>  &nbsp;&nbsp;
                  </button>
                </div>
            </div>
        </div>
    </div>

<!--</ng-container>-->
